
























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardAssesmenPerawat from "@/components/pemeriksaan/assesmen/CardAssesmenPerawat.vue";
import CardAssesmenDokter from "@/components/pemeriksaan/assesmen/CardAssesmenDokter.vue";
import SkriningRawatJalanPage from "@/components/pemeriksaan/SkriningRawatJalanPage.vue";
import RiwayatPerkawinanRalanPage from "@/components/pemeriksaan/assesmen/perkawinan/RiwayatPerkawinanRalanPage.vue";
import { userModule } from "@/store/modules/user";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
// import { storeDiagnosisPemeriksaan } from "@/store/modules/diagnosispemeriksaan";
// import { userModule } from "@/store/modules/user";
// import { storeRencanaPemeriksaan } from "@/store/modules/rencanapemeriksaan";

@Component({
  components: {
    CardAssesmenPerawat,
    CardAssesmenDokter,
    SkriningRawatJalanPage,
    RiwayatPerkawinanRalanPage
  }
})
export default class CardSubAssesmen extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  @Prop({ default: null }) deepLink!: any;
  defaultTab = "tab-perawat";

  // Universal-search deep link, level 3: PasienFlyingBar -> Pemeriksaan ->
  // CardAssesmenV2 (tab-assesmen) -> sub-tab di sini. mounted() menimpa
  // defaultTab untuk user medis, jadi watcher ini dipasang immediate + dicek
  // ulang di mounted (lihat applyDeepLink).
  @Watch("deepLink", { immediate: true })
  onDeepLink(payload) {
    if (!payload || payload.topTab !== "tab-assesmen" || !payload.subTab) {
      return;
    }
    this.defaultTab = payload.subTab;
  }

  get hasDeepLinkSubTab() {
    return !!(
      this.deepLink &&
      this.deepLink.topTab === "tab-assesmen" &&
      this.deepLink.subTab
    );
  }
  // paramPerawat = {
  //   unit_id: this.stateuser.unit_id,
  //   reg: this.register,
  //   profesi: "perawat"
  // };
  paramDokter = {
    unit_id: this.stateuser.unit_id,
    reg: this.register,
    profesi: "Dokter"
  };

  param = {
    unit_id: this.stateuser.unit_id,
    reg: this.register
  };

  get stateuser() {
    return userModule.user;
  }

  get asesmenPerawatDone() {
    return storeAssesmenRalan.asesmenAwal
      ? storeAssesmenRalan.asesmenAwal["perawat_id"]
      : false;
  }

  get asesmenMedisDone() {
    return storeAssesmenRalan.asesmenAwal
      ? storeAssesmenRalan.asesmenAwal["dokter_id"]
      : false;
  }

  // Sembunyikan di Kemoterapi (2H/38) & IGD (01 — punya alur Asesmen Gadar sendiri).
  get showRiwayatPerkawinanTab() {
    return !["2H", "38", "01", "08", "2F"].includes(this.stateuser.unit_id);
  }

  mounted() {
    storeAssesmenRalan.actAsesmenAwal(this.param);

    if (this.stateuser.isMedis && !this.hasDeepLinkSubTab) {
      this.defaultTab = "tab-dokter";
    }
  }

  klikTabPerawat() {
    // const paramPerawat = {
    //   unit_id: this.stateuser.unit_id,
    //   reg: this.register,
    //   profesi: "Perawat",
    // };
    // storeDiagnosisPemeriksaan.actDiagnosis_perawat(paramPerawat);
    // storeRencanaPemeriksaan.actRencanaPemeriksaan_perawat(paramPerawat);
  }

  klikTabSkrining() {
    // Tiap komponen skrining memuat datanya sendiri (lihat SkriningRawatJalanPage).
  }

  klikTabDokter() {
    // storeDiagnosisPemeriksaan.actDiagnosis_dokter(this.paramDokter);
    // storeRencanaPemeriksaan.actRencanaPemeriksaan_perawat(this.paramDokter);
  }

  soap() {
    this.$emit("isiSoap");
  }
}
